
import Vue from 'vue'

export default Vue.extend({
    name: 'Features',
    components: {
    },
    computed: {
        typeFormUrl() {
            const url = new URL(process.env.VUE_APP_CONTACT_US_TYPEFORM || 'https://ws.namecard.ai/intro?src=home');
            url.searchParams.set('src', 'home_features');
            return url.href;
        }
    },
    data(){
        return{
        }
    },
    methods: {
    },
    mounted() {
    }
})
